import config from "../../config";
const baseUrl = config.baseUrl;

export const UsersUrls = {

 USERS_ADD: baseUrl + "/users",
 USERS_EDIT: baseUrl + "/users",
 USERS_STATUS: baseUrl + "/users/changedStatus",
 USERS_LIST: baseUrl + "/users",
 USERS_DELETE: baseUrl + "/users",
 USERS_GETBYID: baseUrl + "/users",
 USERS_ROLLBACK: baseUrl + "/users/rollback",
 USERS_DROPDOWN: baseUrl + "/users/dropdown?export=true", 
 USERS_DROPDOWN_HANDYMAN: baseUrl + "/users/dropdown?export=true&role=3", 
 USERS_DELETE_HARD: baseUrl + "/users",
 PATIENT_COUNT:baseUrl+"/patients/visitcount"
};